import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "scene-mgmt-main" }
const _hoisted_2 = { class: "scene-mgmt-main__content" }

import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { BaseTabs, BaseTabPane } from 'xrk-components';
import IPriceList from '../components/i-price-list.vue';
import APlanList from '../components/a-plan-list.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'scene-mgmt-main',
  setup(__props) {

const route = useRoute();
const functionCode = computed(() => Number(route.meta.functionCode) || 1);

const ALL_TABS = [
  { name: 'industry', label: '工业场景库', component: IPriceList, roles: [1] },
  {
    name: 'provider',
    label: '服务商场景策划',
    component: APlanList,
    roles: [2]
  }
];

const visibleTabs = computed(() =>
  ALL_TABS.filter(tab => tab.roles.includes(functionCode.value))
);

const activeTab = ref(visibleTabs.value[0]?.name || 'industry');

// 角色切换时重置 activeTab 到当前角色第一个可见 Tab
watch(functionCode, () => {
  activeTab.value = visibleTabs.value[0]?.name || 'industry';
});

const TAB_COMPONENT_MAP: Record<string, any> = Object.fromEntries(
  ALL_TABS.map(tab => [tab.name, tab.component])
);

const activeComponent = computed(() => TAB_COMPONENT_MAP[activeTab.value]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTabs), {
      modelValue: activeTab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
      class: "scene-mgmt-tabs"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTabs.value, (tab) => {
          return (_openBlock(), _createBlock(_unref(BaseTabPane), {
            key: tab.name,
            label: tab.label,
            name: tab.name
          }, null, 8, ["label", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(activeComponent.value)))
    ])
  ]))
}
}

})